import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Col, Row, Card, Descriptions, message, Typography, Skeleton } from "antd";

import { getControlsByCode } from "../../API/controls";
import BackButton from "../Common/BackButton/BackButton";
import BreadCrumb from "../Common/BreadCrumb/BreadCrumb";
import PageTitle from "../Common/PageTitle/PageTitle";
import ChangeLog from "../Common/ChangeLog/ChangeLog";
import Assetia from '../Common/Assetia/Assetia';

//import './DependenciesDetail.css';

const { Title, Text } = Typography;

const AssetsDetail = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  const [controlCode, setControlCode] = useState(null);

  useEffect(() => {
    const fetchDependency = async () => {
      try {
        const data = await getControlsByCode(code);
        setControlCode(data);
      } catch (error) {
        message.error("No se encontró el control.");
      }
    };

    fetchDependency();
  }, [code]);

  const breadCrumbUrl = [
    { label: "Controles", url: "/controls" },
    { label: controlCode ? `${controlCode.title}` : "Cargando..." },
  ];

  const goToBioFunctions = () => {
    navigate(-1);
  };

  return (
    <>
      <Row justify="space-between">
        <Col>
          <PageTitle title="Detalle de Controles" icon="controls" />
        </Col>
        <Col>
          <ChangeLog data={controlCode} logs={controlCode?.logs || []} />
        </Col>
      </Row>

      <Row justify="start" align="middle" gutter={16} style={{ marginBottom: 20 }}>
        <Col style={{ display: "flex", alignItems: "center" }}>
          <BackButton onConfirm={goToBioFunctions} />
          <BreadCrumb location={breadCrumbUrl} activeKey={code} />
        </Col>
      </Row>
    {
      !controlCode ? (
      <>
        <Skeleton active paragraph={{ rows: 6 }} />
        <div style={{ height: 32 }} />
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <Skeleton active paragraph={{ rows: 6 }} />
          </Col>
          <Col xs={24} md={12}>
            <Skeleton active paragraph={{ rows: 6 }} />
          </Col>
        </Row>
      </>
      ) : (
      <>
        <Row gutter={[16, 16]} justify="center">
        {/* Card de Información General */}
        <Col xs={24} md={24}>
            <Card hoverable className="detail-card">
            <div className="card-content">
                <div className="text-content">
                <Title className="title-custom" level={4}>Control</Title>

                {controlCode ? (
                    <Descriptions bordered column={1} size="middle">
                    {/* <Descriptions.Item label="Código">
                        <Text strong>{controlCode.code}</Text>
                    </Descriptions.Item> */}
                    <Descriptions.Item label="Título">
                        <Text strong>{controlCode.title}</Text>
                    </Descriptions.Item>
                    <Descriptions.Item label="Descripción">
                        {controlCode.description || "No disponible"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Área">
                        {controlCode.area?.name || "No disponible"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Categoría">
                        {controlCode.category?.name || "No disponible"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Framework">
                        {controlCode.framework?.name || "No disponible"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Prioridad de Implementación">
                        {controlCode.priority?.name || "No disponible"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Riesgo">
                        {controlCode.risk?.name || "No disponible"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Tipo">
                        {controlCode.type?.name || "No disponible"}
                    </Descriptions.Item>
                    </Descriptions>
                ) : (
                    <Text type="secondary">Cargando detalles...</Text>
                )}
                </div>
            </div>
            </Card>
          </Col>
        </Row>

        <Row style={{ marginTop: 80 }}>
          <Assetia 
            pageTitle="detalle de controles" 
            pageDescription="ver en detalle la información de tu control"
            tips={[
              "Consulta el detalle para comprender el impacto de cada control en tu proceso.",
              "Revisa el historial para identificar patrones y posibles áreas de mejora.",
              "Verifica los recursos asociados para entender mejor el control."
            ]}            
          />
        </Row>
      </>
      )
    }
    </>
  );
};

export default AssetsDetail;